/**
 * Platform detection utilities
 * Determines if the app is running in Electron or web browser
 */

/**
 * Check if running in Electron environment
 * @returns {boolean} True if running in Electron
 */
export const isElectron = () => {
  return (
    typeof window !== 'undefined' &&
    (window.electronAPI?.isElectron === true ||
      window.process?.type === 'renderer' ||
      navigator.userAgent.includes('Electron'))
  );
};

/**
 * Check if running in web browser environment
 * @returns {boolean} True if running in web browser
 */
export const isWeb = () => {
  return !isElectron();
};
